import React from 'react';
import ReactDOM from 'react-dom';
import { Button } from '@wearesection/raise-ui/atoms';

function ReactRenderButtonBlock() {
	const raiseButtonBlocks = Array.from( document.querySelectorAll( '.raise-button' ) ) as HTMLElement[];
	raiseButtonBlocks?.length > 0 &&
		raiseButtonBlocks.forEach( ( element: HTMLElement ) => {
			const childrenEle = element?.children?.[0]
			const textContent = childrenEle?.textContent
			const variant = childrenEle?.getAttribute('data-variant') as string
			const href = childrenEle?.getAttribute('href') as string
			const className = childrenEle?.getAttribute('class') as string
			ReactDOM.render(
				<Button href={href} className={className} variant={ variant }>
					{textContent}
				</Button>,
				element,
			);
		} );
}

export default ReactRenderButtonBlock;
